// Mexican Spanish i18n — single source of truth. No hardcoded strings in components.

const dict = {
    brand: { name: "Flotilla MX", tagline: "Gestión de flotilla y maquinaria pesada" },
    common: {
        loading: "Cargando…", save: "Guardar", saving: "Guardando…", cancel: "Cancelar",
        delete: "Eliminar", edit: "Editar", confirm: "Confirmar", close: "Cerrar",
        retry: "Reintentar", signOut: "Cerrar sesión", offline: "Sin conexión",
        clear: "Limpiar", optional: "opcional", confirm: "Confirmar", all: "Todos",
        create: "Crear",
        online: "En línea", ok: "Listo", soon: "Próximamente",
        soonLong: "Esta sección estará disponible en una próxima fase.",
        comingSoon: "(próximamente)",
        yes: "Sí", no: "No", all: "Todos", active: "Activo", inactive: "Inactivo",
        search: "Buscar", none: "—", required: "Requerido",
        backToLogin: "Volver al inicio de sesión", back: "Atrás",
        archived: "Archivado", archive: "Archivar", restore: "Restaurar",
        showArchived: "Mostrar archivados", new: "Nuevo", saved: "Guardado correctamente",
        saveError: "Error al guardar",
        loadError: "Error al cargar los datos",
        confirmArchive: "¿Archivar este registro?",
        confirmRestore: "¿Restaurar este registro?",
        details: "Detalles", actions: "Acciones",
        noRecords: "Sin registros que mostrar.",
        optional: "Opcional",
    },
    validation: {
        required: "Este campo es obligatorio",
        email: "Correo inválido",
        emailRequired: "El correo es obligatorio",
        emailInvalid: "Correo inválido",
        passwordRequired: "La contraseña es obligatoria",
        phone: "Teléfono inválido (10 a 15 dígitos)",
        passwordMin: "La contraseña debe tener al menos 6 caracteres",
        minLength: "Demasiado corto",
        numberInvalid: "Número inválido",
        numberPositive: "Debe ser mayor a cero",
        numberNonNegative: "No puede ser negativo",
        yearRange: "Año inválido",
        dateFuture: "La fecha debe ser futura",
        dateInvalid: "Fecha inválida",
        duplicate: "Ya existe un registro con ese valor",
        atLeastOneMeter: "Captura al menos odómetro u horímetro",
        userOrCreate: "Vincula un usuario o crea uno nuevo",
    },
    auth: { notAllowed: "Requiere permisos de administrador", sessionExpired: "Sesión expirada, vuelve a iniciar sesión." },
    login: {
        title: "Iniciar sesión", subtitle: "Acceso para personal autorizado",
        email: "Correo electrónico", emailPlaceholder: "tu@empresa.mx",
        password: "Contraseña", passwordPlaceholder: "••••••••",
        submit: "Entrar", submitting: "Entrando…",
        demoSection: "Acceso demo", demoAdmin: "Entrar como Admin Demo",
        demoOperator: "Entrar como Operador Demo",
        invalid: "Credenciales inválidas",
        networkError: "Error de red. Verifica tu conexión.",
    },
    nav: {
        panel: "Panel", assets: "Activos", operators: "Operadores", clients: "Clientes",
        materials: "Materiales", jobs: "Trabajos", maintenance: "Mantenimiento",
        verification: "Verificación", finance: "Finanzas", expenses: "Gastos",
        tolls: "Casetas",
        users: "Usuarios", settings: "Configuración",
        home: "Inicio", myJobs: "Mis trabajos", camera: "Cámara", profile: "Perfil",
    },
    adminPanel: {
        title: "Panel de Administración", welcome: "Bienvenido,",
        operationsKpis: "Indicadores operativos",
        kpis: {
            revenue: "Ingresos del mes", expenses: "Gastos del mes",
            netProfit: "Utilidad neta", assets: "Activos en trabajo / disponibles",
        },
        alerts: "Alertas activas",
        noAlerts: "No hay alertas configuradas todavía.",
        noActiveAlerts: "Sin alertas. Todos los recordatorios están al día.",
        viewAllAlerts: "Ver todas",
        anomalies: {
            title: "Alertas de anomalías",
            subtitle: "Lecturas atípicas y cargas marcadas para revisión.",
            empty: "Sin anomalías. Todo en orden.",
            typeMeter: "Lectura de medidor",
            typeFuel: "Carga de combustible",
        },
        utilization: {
            title: "Utilización de flota",
            subtitle: "Porcentaje del mes actual. Naranja: bajo 40%.",
            topUsed: "Más utilizados",
            leastUsed: "Menos utilizados",
            empty: "Sin datos de utilización del mes actual.",
            colAsset: "Activo",
            colInUse: "Días en uso",
            colUtil: "% Util",
            viewDetail: "Ver detalle",
            loadError: "No se pudo cargar la utilización.",
        },
    },
    soon: { heading: "Próximamente", sub: "Esta sección se implementará en una próxima fase. La estructura de datos ya está lista en la base de datos." },
    finance: {
        title: "Finanzas y reportes",
        subtitle: "Estado de resultados, cuentas por cobrar y exportación a Excel.",
        tabs: {
            summary: "Resumen", byAsset: "Por activo", byOperator: "Por operador",
            byClient: "Por cliente", receivables: "Cuentas por cobrar", cashflow: "Flujo de efectivo",
        },
        range: { thisMonth: "Mes actual", lastMonth: "Mes pasado", ytd: "Año a la fecha", last6m: "Últimos 6 meses", custom: "Personalizado" },
        kpi: { revenue: "Ingresos", costs: "Costos totales", netProfit: "Utilidad neta", margin: "Margen %" },
        monthlyTrend: "Tendencia mensual",
        chartEmpty: "Sin datos para graficar en este rango.",
        legendRevenue: "Ingresos", legendCosts: "Costos", legendNet: "Utilidad",
        byCategory: "Por categoría de gasto",
        internalVsExternal: "Interno vs Externo",
        internal: "Interno", external: "Externo",
        totalCosts: "Total de costos",
        topJobs: "Top 5 trabajos por ingreso",
        code: "Código", clientLabel: "Cliente", cls: "Clasificación",
        revenue: "Ingreso", opPay: "Pago operador", gross: "Utilidad bruta",
        startDate: "Inicio",
        noJobsInRange: "Sin trabajos en este rango.",
        exportXlsx: "Exportar Excel",
        cat: {
            operatorPay: "Pago a operadores (externo)",
            fuel: "Combustible",
            maintenance: "Mantenimiento",
            financing: "Pagos de financiamiento",
            salaries: "Salarios fijos (interno)",
            tolls: "Casetas",
            general: "Gastos generales",
        },
        opEarn: {
            baseSalary: "Salario base (prorrateado)",
            externalPay: "Pago externo total",
            grandTotal: "Total cost-to-business",
            byJob: "Pago externo por trabajo",
            noExternal: "Este operador no participó en trabajos externos en este rango.",
        },
        client: {
            totalBilled: "Total facturado", totalPaid: "Total pagado", outstanding: "Pendiente",
            jobs: "Trabajos", paid: "Pagado", payStatus: "Status de pago",
            materialsMoved: "Materiales transportados", material: "Material", totalQty: "Cantidad",
        },
        recv: {
            pending: "Pendientes", partial: "Parciales",
            totalOutstanding: "Total pendiente",
            jobsWord: "trabajos",
            outstanding: "Pendiente", daysOpen: "Días",
            markPaid: "Marcar pagado",
            markPaidTitle: "Registrar pago",
            amountToPay: "Monto a registrar (MXN)",
            payFull: "Pagar total",
            confirmPayment: "Confirmar pago",
            empty: "Sin cuentas por cobrar. ¡Todo cobrado!",
            errOverpay: "El monto excede el ingreso total del trabajo.",
        },
        cash: {
            inflow: "Entradas (cobros)", outflowOp: "Salidas operativas",
            outflowFin: "Salidas financiamiento", net: "Flujo neto",
            financedAssets: "Activos financiados",
            asset: "Activo", lender: "Acreedor",
            monthlyPayment: "Pago mensual", remainingBalance: "Saldo restante",
            monthsLeft: "Meses restantes", months: "meses",
        },
    },
    users: {
        title: "Usuarios", subtitle: "Gestiona cuentas de administrador, gerente y operador.",
        addUser: "Agregar usuario", editUser: "Editar usuario",
        resetPassword: "Restablecer contraseña",
        deactivate: "Desactivar", activate: "Activar",
        columns: { name: "Nombre", email: "Correo", phone: "Teléfono", role: "Rol", status: "Estado", actions: "Acciones" },
        filters: { role: "Rol", status: "Estado" },
        fields: { fullName: "Nombre completo", email: "Correo", phone: "Teléfono (opcional)", role: "Rol", password: "Contraseña", passwordHint: "Mínimo 6 caracteres", newPassword: "Nueva contraseña" },
        empty: "Aún no hay usuarios que coincidan con los filtros.",
        created: "Usuario creado correctamente.", updated: "Usuario actualizado.",
        passwordChanged: "Contraseña actualizada.",
        deactivated: "Usuario desactivado.", activated: "Usuario reactivado.",
        you: "tú",
    },
    roles: { admin: "Administrador", manager: "Gerente", operator: "Operador" },
    operator: {
        homeTitle: "Hoy",
        greetingMorning: "Buen día,", greetingAfternoon: "Buena tarde,", greetingEvening: "Buena noche,",
        startShift: "Iniciar jornada", endShift: "Terminar jornada",
        shiftActive: "Jornada en curso", shiftActiveSince: "Iniciada a las",
        myJobsToday: "Mis trabajos de hoy", zeroJobs: "0 trabajos asignados",
        singularJob: "trabajo asignado", pluralJobs: "trabajos asignados",
        cameraTitle: "Captura de evidencia", jobsTitle: "Mis trabajos",
        jobsEmpty: "Aún no tienes trabajos asignados.",
        profileTitle: "Mi perfil",
        profileSoon: "Configuración de perfil disponible próximamente.",
        accountInfo: "Información de la cuenta",
        takePhoto: "Tomar foto", uploadPhoto: "Subir foto existente",
        upload: "Subir", uploading: "Subiendo…",
        preview: "Vista previa", clear: "Quitar",
        recent: "Mis fotos recientes", none: "Aún no has subido fotos.",
        pendingUploads: "Pendientes de subir", syncNow: "Sincronizar ahora",
        synced: "Sincronizado", queued: "Foto guardada para subir cuando vuelva la conexión.",
        uploaded: "Foto subida correctamente.", uploadFailed: "No se pudo subir la foto.",
    },
    assets: {
        title: "Activos", subtitle: "Camiones y maquinaria pesada en operación.",
        newAsset: "Nuevo activo", editAsset: "Editar activo",
        cols: { nickname: "Apodo", kind: "Tipo", subtype: "Subtipo", plate: "Placa/Eco",
            brand: "Marca", model: "Modelo", year: "Año", status: "Estado", expires: "Vence" },
        sortByUrgency: "Ordenar por urgencia",
        daysUnit: "días",
        rowLabels: { plate: "Placa/Eco", brand: "Marca", model: "Modelo", year: "Año", vin: "VIN",
            odometer: "Odómetro", hourMeter: "Horímetro", mode: "Modalidad", lender: "Acreedor",
            total: "Total", monthly: "Pago mensual", insurance: "Seguro", registration: "Placas" },
        kinds: { camion: "Camión", maquinaria: "Maquinaria" },
        status: { disponible: "Disponible", en_trabajo: "En trabajo",
            en_mantenimiento: "En mantenimiento", fuera_servicio: "Fuera de servicio" },
        sections: {
            ident: "Identificación", meters: "Medidores", status: "Estado",
            ownership: "Propiedad y financiamiento", expiries: "Vencimientos",
            checklist: "Checklist de fotos",
        },
        fields: {
            kind: "Tipo", subtype: "Subtipo", nickname: "Apodo",
            plate: "Placa o número económico", brand: "Marca", model: "Modelo", year: "Año",
            vin: "VIN / serial", photo: "Foto principal",
            odometer: "Odómetro (km)", hourMeter: "Horímetro (horas)",
            metersHint: "Captura al menos uno (los camiones suelen tener ambos)",
            status: "Estado actual",
            financingMode: "Modalidad", efectivo: "Pagado en efectivo", financiado: "Financiado",
            lender: "Institución / acreedor", total: "Monto total MXN", down: "Enganche MXN",
            monthly: "Pago mensual MXN", rate: "Tasa de interés %", term: "Plazo (meses)",
            startDate: "Fecha de inicio",
            insuranceExpiry: "Vence seguro", regExpiry: "Vence placas/registro",
            checklistConfig: "Checklist asignado",
            useDefault: "Usar checklist por defecto del subtipo",
            remainingBalance: "Saldo restante estimado",
        },
        filters: { kind: "Tipo", status: "Estado", subtype: "Subtipo" },
        empty: "Aún no hay activos. Crea el primero.",
        expiringSoon: "Vence pronto", expired: "Vencido",
        detail: { title: "Detalle del activo", recentMeter: "Lectura más reciente",
            recentMeterPlaceholder: "Sin lecturas todavía. Se llenará automáticamente cuando los operadores capturen medidores en sus reportes.",
            maintenance: "Historial de mantenimiento",
            maintenancePlaceholder: "Sin historial todavía.",
            usageThisMonth: "Días en uso este mes",
            tabs: { overview: "Resumen", meterHistory: "Histórico de medidor", utilization: "Utilización" },
        },
        utilization: {
            rangeLabel: "Rango",
            from: "Desde", to: "Hasta",
            applyRange: "Aplicar",
            presetThisMonth: "Mes actual",
            presetLast30: "Últimos 30 días",
            presetYTD: "Año en curso",
            kpiDaysInUse: "Días en uso",
            kpiDaysMaint: "Días en mantenimiento",
            kpiDaysAvail: "Días disponibles",
            kpiUtilPct: "% Utilización",
            kpiProductivePct: "% Productivo",
            chartTitle: "Utilización mensual (últimos 12 meses)",
            chartHint: "Cada barra es el % de utilización del mes calendario completo.",
            tableTitle: "Detalle por mes",
            colMonth: "Mes",
            colInUse: "En uso",
            colMaint: "Mant.",
            colAvail: "Disp.",
            colUtil: "% Util",
            empty: "Sin datos de utilización para este rango.",
            loadError: "No se pudo cargar la utilización.",
        },
        meterHistory: {
            empty: "Aún no hay lecturas para este activo.",
            singlePointHint: "Datos insuficientes para mostrar tendencia. Se necesitan al menos 2 lecturas.",
            kindFilter: "Tipo de medidor",
            all: "Todas",
            colDate: "Fecha", colValue: "Valor", colKind: "Tipo", colJob: "Trabajo",
            colStatus: "Estado", colDelta: "Δ",
            trendTitle: "Tendencia",
        },
    },
    operators: {
        title: "Operadores", subtitle: "Personal de campo y compensación base.",
        newOperator: "Nuevo operador", editOperator: "Editar operador",
        cols: { name: "Nombre", phone: "Teléfono", license: "Licencia",
            licenseExpiry: "Vence", salary: "Sueldo base", user: "Usuario", status: "Estado" },
        sections: {
            personal: "Datos personales", account: "Cuenta de usuario",
            license: "Licencia", compensation: "Compensación base",
            documents: "Documentos",
        },
        fields: {
            fullName: "Nombre completo", phone: "Teléfono",
            licenseNumber: "Número de licencia", licenseExpiry: "Vencimiento de licencia",
            baseSalary: "Sueldo base mensual MXN",
            extBase: "Tarifa base/día (externo) MXN",
            extCommission: "Comisión externa %",
            extBonus: "Bono fijo externo MXN",
            userMode: "Vinculación de usuario",
            modeCreate: "Crear nuevo usuario operador",
            modeExisting: "Vincular usuario existente",
            modeNone: "Sin usuario por ahora",
            existingUser: "Usuario disponible",
            email: "Correo del nuevo usuario", password: "Contraseña inicial",
        },
        empty: "Aún no hay operadores. Crea el primero.",
        licenseSoon: "Vence pronto", licenseExpired: "Vencida",
        documentsHint: "Sube fotografías o escaneos de identificaciones, licencias o contratos.",
        addDocument: "Agregar documento",
        detail: { jornadas: "Historial de jornadas",
            jornadasPlaceholder: "Sin jornadas registradas todavía.",
            ingresos: "Historial de ingresos",
            ingresosPlaceholder: "Phase 6 — se calculará a partir de los trabajos asignados.",
        },
        noAvailableUsers: "No hay usuarios operadores disponibles para vincular.",
    },
    clients: {
        title: "Clientes", subtitle: "Empresas y dependencias que contratan tus servicios.",
        newClient: "Nuevo cliente", editClient: "Editar cliente",
        cols: { name: "Nombre", contact: "Contacto", phone: "Teléfono", email: "Correo", address: "Dirección", status: "Estado" },
        fields: {
            name: "Nombre o razón social", contact: "Persona de contacto",
            phone: "Teléfono", email: "Correo electrónico",
            address: "Dirección", notes: "Notas internas",
        },
        empty: "Aún no hay clientes. Crea el primero.",
        searchPlaceholder: "Buscar por nombre…",
        detail: {
            jobs: "Trabajos del cliente", totalBilled: "Total facturado",
            pending: "Saldo pendiente", materials: "Materiales transportados",
            placeholder: "Datos disponibles cuando existan trabajos asociados.",
        },
    },
    materials: {
        title: "Materiales", subtitle: "Tipos de carga / material movido en los trabajos.",
        newMaterial: "Nuevo material", editMaterial: "Editar material",
        cols: { name: "Nombre", unit: "Unidad", notes: "Notas", status: "Estado" },
        units: { m3: "m³", viajes: "Viajes", toneladas: "Toneladas" },
        empty: "Sin materiales. Crea uno.",
        fields: { name: "Nombre", unit: "Unidad", notes: "Notas (opcional)" },
    },
    checklists: {
        title: "Checklists de fotos", subtitle: "Define qué fotos se piden por subtipo de activo.",
        newConfig: "Nuevo checklist", editConfig: "Editar checklist",
        cols: { subtype: "Subtipo", baseCount: "Base", extraCount: "Adicionales", total: "Total" },
        sections: { base: "Base (no editable)", extras: "Adicionales por subtipo" },
        fields: { subtype: "Subtipo del activo", key: "Llave (sin espacios)", label: "Etiqueta en español", required: "Obligatoria" },
        addEntry: "Agregar entrada", removeEntry: "Quitar",
        baseTooltip: "Estas 5 fotos siempre son obligatorias y no se pueden quitar de ningún checklist.",
        empty: "Sin checklists configurados.",
    },
    jobs: {
        title: "Trabajos", subtitle: "Asigna activos, operadores y materiales a cada trabajo.",
        newJob: "Nuevo trabajo", editJob: "Editar trabajo",
        empty: "Aún no hay trabajos registrados. Comienza creando el primero.",
        cols: { code: "Código", client: "Cliente", start: "Fecha inicio", end: "Fecha fin",
            assets: "Activos", operators: "Operadores", classification: "Tipo",
            revenue: "Ingreso", status: "Estado", payment: "Pago" },
        statusLabel: { programado: "Programado", en_progreso: "En progreso", completado: "Completado", cancelado: "Cancelado" },
        classLabel: { interno: "Interno", externo: "Externo" },
        paymentLabel: { pagado: "Pagado", pendiente: "Pendiente", parcial: "Parcial" },
        methodLabel: { efectivo: "Efectivo", transferencia: "Transferencia", credito: "Crédito" },
        sections: {
            general: "Datos generales",
            classification: "Clasificación",
            assets: "Activos asignados",
            operators: "Operadores asignados",
            materials: "Materiales transportados",
            revenue: "Ingreso y pago",
            initialStatus: "Estado inicial",
            summary: "Resumen del trabajo",
            externalPayDetail: "Pago a operadores",
            history: "Historial de estado",
            photos: "Fotos del trabajo",
        },
        fields: {
            client: "Cliente",
            description: "Descripción del trabajo",
            location: "Ubicación / domicilio",
            startDate: "Fecha de inicio",
            endDate: "Fecha de fin",
            classification: "Tipo de trabajo",
            interno: "Interno (operadores propios)",
            externo: "Externo (con pago por trabajo)",
            renta: "Renta (sin operador propio)",
            assets: "Activos",
            operators: "Operadores",
            materials: "Materiales",
            material: "Material",
            quantity: "Cantidad",
            unit: "Unidad",
            revenue: "Ingreso (MXN)",
            paymentMethod: "Método de pago",
            paymentStatus: "Estado de pago",
            amountPaid: "Monto pagado (MXN)",
            initialStatus: "Estado al guardar",
            basePerDay: "Base / día",
            commissionPct: "% comisión",
            bonus: "Bono fijo",
            days: "Días",
            total: "Total",
            note: "Nota",
            cancelReason: "Motivo de cancelación",
        },
        info: {
            internoCovered: "Los operadores asignados están cubiertos por su sueldo mensual base. No se agrega pago por trabajo.",
            externoMissingRevenue: "(falta ingreso para calcular comisión)",
            marginDisclaimer: "El margen excluye combustible, mantenimiento y casetas. El cálculo neto estará disponible en Finanzas.",
            photosLater: "Las fotos antes/después se capturan desde la vista de operador. (Disponible en Phase 4)",
            grossRevenue: "Ingreso bruto",
            operatorPayout: "Pago total a operadores",
            estimatedMargin: "Margen estimado",
            assignAtLeastOne: "Asigna al menos un activo o un operador.",
            noMaterials: "Sin materiales asignados.",
            addMaterial: "Agregar material",
            removeMaterial: "Quitar material",
            duplicateMaterial: "No puedes repetir el mismo material",
            quantityPositive: "La cantidad debe ser mayor a cero",
            amountPaidPositive: "El monto pagado parcial debe ser mayor a 0 y menor al ingreso",
            assetsUnavailable: "Uno o más activos no están disponibles",
            externalPayMissing: "Captura el pago externo para cada operador asignado",
            startBeforeEnd: "La fecha fin no puede ser anterior a la fecha de inicio",
            cancelReasonRequired: "Captura el motivo de cancelación",
        },
        actions: {
            view: "Ver",
            start: "Iniciar trabajo",
            complete: "Marcar como completado",
            cancel: "Cancelar trabajo",
        },
        fieldTabs: {
            title: "Operaciones de campo",
            photos: "Fotos",
            readings: "Lecturas",
            fuel: "Combustible",
            viajes: "Viajes",
            empty: "Sin registros para esta sección.",
            antes: "Antes",
            despues: "Después",
            dano: "Daño",
            otro: "Otro",
            asset: "Activo",
            operator: "Operador",
            moment: "Momento",
            checklistKey: "Punto",
            takenAt: "Fecha",
            kind: "Tipo",
            value: "Valor",
            flagged: "Marcada",
            verified: "Verificada",
            liters: "Litros",
            cost: "Costo",
            kml: "km/L",
            lph: "L/h",
            anomaly: "Anomalía",
            viajeNumber: "#",
            origin: "Origen",
            destination: "Destino",
            material: "Material",
            quantity: "Cantidad",
        },
        operator: {
            myJobs: "Mis trabajos",
            empty: "No tienes trabajos asignados todavía.",
            tapForDetail: "Toca un trabajo para ver el detalle.",
            startCapture: "Iniciar registro de campo",
            captureLater: "El registro de campo (fotos antes/después, lecturas de medidor y combustible) estará disponible en la siguiente fase.",
            coworkers: "Compañeros",
            statusCol: "Estado",
        },
        title: "Registro de campo",
        subtitle: "Captura fotos antes/después y lecturas de medidor.",
        sectionA: "A. Fotos antes",
        sectionB: "B. Lectura de medidor",
        sectionC: "C. Combustible",
        sectionD: "D. Viajes",
        sectionE: "E. Máquina en espera",
        sectionF: "F. Fotos después",
        sectionG: "G. Cierre del trabajo",
        sectionH: "H. Casetas",
        required: "Requerida", optional: "Opcional",
        take: "Tomar foto", retake: "Retomar",
        lastReading: "Última lectura", enterValue: "Valor",
        photoOfMeter: "Foto del medidor", saveReading: "Guardar lectura",
        invalidReading: "Captura un valor numérico válido.",
        readingLowerThan: "La lectura no puede ser menor a",
        beforeIncomplete: "faltan fotos antes",
        afterIncomplete: "faltan fotos después",
        meterMissing: "falta lectura de medidor",
        missing: "Falta para cerrar:", requestClosure: "Solicitar cierre del trabajo",
        pickAsset: "Selecciona un activo",
        fuelRequired: "Captura litros y costo total.",
        liters: "Litros", totalCost: "Costo total (MXN)",
        hoursIn: "Horas inicio", hoursOut: "Horas fin",
        ticketPhoto: "Foto del ticket", saveFuel: "Guardar carga",
        outOfRange: "Fuera de rango",
        viajeRequired: "Activo, material y cantidad son obligatorios.",
        origin: "Origen", destination: "Destino", quantity: "Cantidad",
        addViaje: "Nuevo viaje", viajesCount: "Viajes registrados",
        idleOn: "Máquina en espera", idleOff: "Máquina activa",
        idleReason: "Razón (opcional): falta material, falta personal, etc.",
        markIdle: "Marcar en espera", resume: "Reanudar",
        queuedOffline: "Guardado offline, se sincronizará al reconectar.",
        toll: {
            addToll: "+ Registrar caseta",
            formTitle: "Nueva caseta",
            asset: "Activo",
            date: "Fecha",
            location: "Ubicación",
            locationPh: "Ej. Caseta Hermosillo-Esperanza",
            amount: "Monto (MXN)",
            amountPh: "0.00",
            photo: "Foto del ticket",
            photoOptional: "Foto (opcional)",
            notes: "Notas",
            notesPh: "Notas (opcional)",
            save: "Guardar caseta",
            cancel: "Cancelar",
            missingFields: "Captura ubicación y monto.",
            invalidAmount: "El monto debe ser mayor a cero.",
            empty: "Sin casetas registradas en este trabajo.",
            registered: "Casetas registradas",
            total: "Total",
        },
    },
    attendance: {
        title: "Mi jornada",
        notStarted: "Aún no inicias tu jornada de hoy.",
        startShift: "Iniciar jornada", endShift: "Terminar jornada",
        ongoing: "En jornada desde",
        ended: "Jornada terminada a las",
        noteOptional: "Nota (opcional)",
        checkInError: "No se pudo iniciar la jornada",
        checkOutError: "No se pudo terminar la jornada",
        queuedCheckIn: "Inicio guardado, se sincronizará al reconectar",
        queuedCheckOut: "Cierre guardado, se sincronizará al reconectar",
    },
    pending: {
        label: "Pendientes",
        none: "Sin pendientes",
        syncNow: "Sincronizar ahora",
        synced: "Sincronizado",
        partial: "Algunos pendientes no se pudieron sincronizar",
    },
    publicLink: {
        sectionTitle: "Link público de seguimiento",
        enable: "Activar link público",
        share: "Compartir link público",
        regenerate: "Regenerar enlace",
        disable: "Desactivar",
        copy: "Copiar enlace",
        copied: "Enlace copiado",
        whatsapp: "Compartir por WhatsApp",
        stats: "Estadísticas",
        viewCount: "Visto",
        viewsLabel: "veces",
        lastViewedAt: "Último acceso",
        never: "Sin accesos aún",
        regenerateConfirm: "¿Regenerar el enlace? El enlace anterior dejará de funcionar.",
        disabledNotice: "El link está desactivado. Visitantes verán 'Enlace no disponible'.",
        explainer: "Comparte este link con el cliente. Verá el estado del trabajo y la galería de fotos antes/después. No requiere cuenta ni login.",
        whatsappTemplate: "Seguimiento del trabajo {code} - {client}\n{url}\n— Flotilla MX",
    },
    track: {
        loading: "Cargando seguimiento del trabajo…",
        notAvailable: "Enlace no disponible",
        notAvailableHint: "Este enlace ya no está activo o nunca existió. Pídele al taller un nuevo enlace.",
        client: "Cliente",
        location: "Ubicación",
        period: "Periodo",
        description: "Descripción",
        assetsTitle: "Activos en el trabajo",
        materialsTitle: "Materiales",
        materialsHeaderName: "Material",
        materialsHeaderQty: "Cantidad",
        materialsHeaderUnit: "Unidad",
        viajesTitle: "Viajes realizados",
        photosTitle: "Galería de fotos",
        antes: "Antes",
        despues: "Después",
        noPhotos: "Aún no hay fotos disponibles.",
        footerBy: "Generado por Flotilla MX",
        footerGenerated: "Generado",
        cancelledBanner: "Este trabajo fue cancelado.",
    },
    verify: {
        pendingBadge: "Pendiente",
        title: "Verificación de medidores",
        subtitle: "Confirma o marca las lecturas capturadas por operadores.",
        pending: "Pendientes",
        verifiedMonth: "Verificadas (mes)",
        flagged: "Marcadas",
        filter: { pending: "Pendientes", verified: "Verificadas", flagged: "Marcadas", all: "Todas" },
        empty: "No hay lecturas en este filtro.",
        kmLabel: "km", hoursLabel: "horas",
        verifiedBadge: "Verificada", flaggedBadge: "Marcada",
        asset: "Activo", job: "Trabajo", operator: "Operador", takenAt: "Capturada",
        confirm: "Confirmar", flag: "Marcar", reset: "Resetear",
        flagTitle: "Marcar para revisión",
        flagHelp: "Describe brevemente por qué esta lectura necesita revisión.",
        flagPlaceholder: "Ej. La foto no corresponde con el valor capturado",
        flagConfirm: "Marcar",
    },
    maintenance: {
        title: "Mantenimiento", subtitle: "Bitácora, recordatorios y alertas de la flotilla.",
        tabs: { logs: "Bitácora", reminders: "Recordatorios", alerts: "Alertas" },
        newLog: "Nuevo registro", newReminder: "Nuevo recordatorio",
        asset: "Activo", date: "Fecha", kind: "Tipo", description: "Descripción",
        vendor: "Taller", parts: "Refacciones (MXN)", labor: "Mano de obra (MXN)",
        odometerKm: "Odómetro (km)", hoursMeter: "Horómetro (h)",
        linkReminder: "Vincular recordatorio",
        preventivo: "Preventivo", correctivo: "Correctivo",
        totalCost: "Costo total", meterAtService: "Lectura",
        label: "Etiqueta", interval: "Intervalo",
        intervalsHelp: "Al menos un intervalo (km, horas o días) es requerido",
        intervalKm: "Cada (km)", intervalHours: "Cada (horas)", intervalDays: "Cada (días)",
        lastServiced: "Último servicio", lastServicedDate: "Fecha último servicio",
        nextDue: "Próximo vencimiento", status: "Estado",
        overdue: "Vencido", dueSoon: "Próximo", ok: "OK",
        overdueSection: "Vencidos", dueSoonSection: "Próximos a vencer",
        alertsClear: "Sin alertas. Todos los recordatorios están al día.",
        registerService: "Registrar servicio",
        days: "días",
        emptyLogs: "Aún no hay registros de mantenimiento.",
        emptyReminders: "Aún no hay recordatorios configurados.",
        requiredAssetDesc: "Activo y descripción son requeridos",
        requiredAssetLabel: "Activo y etiqueta son requeridos",
        requiredInterval: "Define al menos un intervalo (km, horas o días)",
        filterActive: "Filtro activo",
    },
    dashboardKpi: {
        pendingReadings: "Lecturas por verificar",
        maintenanceOverdue: "Mantenimientos vencidos",
        maintenanceDueSoon: "Mantenimientos próximos",
        insuranceExpiring: "Seguros por vencer (30d)",
        registrationExpiring: "Tarjetas circulación (30d)",
        jobsInProgress: "Trabajos en progreso",
    },
    expenses: {
        title: "Gastos generales",
        subtitle: "Captura los gastos administrativos y operativos no asociados a un trabajo específico.",
        newExpense: "Nuevo gasto", editExpense: "Editar gasto",
        totalMonth: "Total del mes", totalYear: "Total del año",
        searchPh: "Buscar descripción o nota",
        allCategories: "Todas las categorías",
        recurringAll: "Recurrentes y únicos", recurringYes: "Solo recurrentes", recurringNo: "Solo únicos",
        isRecurring: "Gasto recurrente",
        recurringPeriod: "Frecuencia",
        notesLabel: "Notas (opcional)",
        empty: "No hay gastos registrados con estos filtros.",
        confirmDel: "¿Eliminar este gasto?",
        cols: { date: "Fecha", category: "Categoría", description: "Descripción", amount: "Monto", recurring: "Recurrente" },
        categories: {
            oficina: "Oficina", permisos_licencias: "Permisos y licencias",
            seguros_bloque: "Seguros en bloque", sueldos_admin: "Sueldos admin",
            impuestos: "Impuestos", honorarios: "Honorarios profesionales", otros: "Otros",
        },
        periods: { mensual: "Mensual", trimestral: "Trimestral", anual: "Anual" },
    },
    tolls: {
        title: "Casetas y peajes",
        subtitle: "Registra los pagos de caseta asociados a cada trabajo.",
        newToll: "Nueva caseta", editToll: "Editar caseta",
        totalRegistered: "Total registrado", tollsWord: "casetas",
        allJobs: "Todos los trabajos", allAssets: "Todos los activos",
        empty: "Sin casetas registradas con estos filtros.",
        confirmDel: "¿Eliminar esta caseta?",
        locationPh: "Ej. Caseta Hermosillo-Esperanza",
        notesLabel: "Notas (opcional)",
        cols: { date: "Fecha", job: "Trabajo", asset: "Activo", location: "Ubicación", amount: "Monto" },
    },
};

// Alias kept for legacy code that reads dict.fieldOps.*; same content as dict.jobs.*
dict.fieldOps = dict.jobs;

// Generic UI-wide error boundary copy (Mexican Spanish).
dict.errorBoundary = {
    title: "Algo salió mal",
    description: "Ocurrió un error inesperado. Intenta refrescar la página o contacta a soporte.",
    descriptionRegistro: "Ocurrió un error al cargar el registro de campo. Intenta refrescar la página o contacta a soporte.",
    refresh: "Refrescar",
    back: "Volver atrás",
    details: "Detalles técnicos",
};

// Service Worker update banner
dict.sw = {
    title: "Nueva versión disponible",
    description: "Actualiza para obtener los últimos cambios y correcciones.",
    applyNow: "Actualizar",
    later: "Después",
};

// Phase 8 — vista 360 del activo + documentos por vencer + edición mantenimiento
dict.expiring = {
    title: "Documentos por vencer",
    subtitle: "Seguro y placas en los próximos 30 días.",
    empty: "Todo al día. Sin documentos por vencer en los próximos 30 días.",
    expiredAgo: "Vencido hace",
    expiresIn: "Vence en",
    daysLabel: "días",
    today: "Vence hoy",
    expired: "Vencido",
    docInsurance: "Seguro",
    docRegistration: "Placas",
    loadError: "No se pudo cargar el listado.",
};

dict.asset360 = {
    tabs: {
        jobs: "Trabajos",
        maintenance: "Mantenimiento",
        photos: "Fotos",
        fuel: "Combustible",
        costs: "Costos totales",
    },
    jobs: {
        empty: "Este activo no ha participado en ningún trabajo.",
        cols: { code: "Código", client: "Cliente", description: "Descripción", dates: "Fechas", status: "Estado", revenue: "Ingreso" },
        viewDetail: "Ver",
    },
    maintenance: {
        empty: "Sin registros de mantenimiento.",
        addNew: "+ Nuevo registro",
        cols: { date: "Fecha", kind: "Tipo", description: "Descripción", vendor: "Proveedor", cost: "Costo total" },
    },
    photos: {
        empty: "Sin fotos vinculadas a este activo.",
    },
    fuel: {
        empty: "Sin registros de combustible.",
        kpiLiters: "Total litros",
        kpiCost: "Costo total",
        kpiAvgKml: "Rendimiento promedio",
        cols: { date: "Fecha", liters: "L", cost: "Costo", kml: "km/L" },
    },
    costs: {
        title: "Costos totales",
        subtitle: "Suma de gastos asociados al activo en el rango seleccionado.",
        from: "Desde", to: "Hasta",
        fuel: "Combustible",
        maintenance: "Mantenimiento",
        tolls: "Casetas",
        financing: "Financiamiento",
        total: "Total",
        empty: "Sin costos registrados en este rango.",
    },
};

dict.jobs.fields.revenueFacturado = "Ingreso facturado (transferencia/crédito)";
dict.jobs.fields.revenueEfectivo = "Ingreso en efectivo (no facturado)";
dict.jobs.fields.totalRevenue = "Ingreso total";
dict.jobs.fields.payMode = "Modo de pago externo";
dict.jobs.fields.payModePorDia = "Por día";
dict.jobs.fields.payModePorViaje = "Por viaje";
dict.jobs.fields.basePerTrip = "Tarifa por viaje (MXN)";
dict.jobs.fields.minimoViajes = "Mínimo de viajes";
dict.jobs.fields.viajesRealizados = "Viajes registrados";
dict.jobs.info = dict.jobs.info || {};
dict.jobs.info.revenueRequired = "Debes registrar al menos un monto de ingreso (facturado o efectivo).";
dict.jobs.info.payModePorViajeHint = "Se actualizará al registrar viajes en campo.";
dict.jobs.info.payModePorViajeBelowMin = "Faltan {n} viaje(s) para activar comisión y bono.";
dict.jobs.info.payModePorViajeAboveMin = "Comisión y bono activos.";
dict.jobs.info.payModeOperatorNotice = "Modo de pago: Por viaje — debes realizar al menos {n} viaje(s) en este trabajo.";

dict.assets.statusFilter = "Filtrar por estado";
dict.assets.statusFilterShowAll = "Mostrar todos";

dict.maintenance = dict.maintenance || {};
dict.maintenance.editLog = "Editar mantenimiento";
dict.maintenance.editAction = "Editar";
dict.maintenance.deleteAction = "Eliminar";
dict.maintenance.editedOk = "Mantenimiento actualizado correctamente";
dict.maintenance.confirmDelete = "¿Eliminar este registro?";

// ============================================================
// Phase 10 — Módulo Combustible
// ============================================================
dict.nav.fuel = "Combustible";

dict.fuel = {
    title: "Combustible",
    subtitle: "Cargas de combustible por activo, operador y trabajo.",
    newBtn: "Nueva carga",
    empty: "Aún no hay cargas de combustible registradas. Comienza registrando la primera.",
    loadError: "Error al cargar las cargas de combustible",
    saveOk: "Carga registrada",
    updateOk: "Carga actualizada",
    deleteOk: "Carga eliminada",
    confirmDelete: "¿Eliminar esta carga de combustible?",
    kpi: {
        thisMonth: "Este mes",
        thisYear: "Este año",
        avgPerLiter: "Costo prom. por litro",
        fleetKml: "Rendimiento flota",
        litersSuffix: "litros",
    },
    filters: {
        title: "Filtros",
        asset: "Activo",
        allAssets: "Todos los activos",
        operator: "Operador",
        allOperators: "Todos los operadores",
        fuelType: "Tipo",
        paymentMethod: "Método pago",
        dateRange: "Rango",
        onlyNoJob: "Solo sin trabajo",
        clear: "Limpiar filtros",
    },
    types: {
        gasolina: "Gasolina",
        diesel: "Diesel",
        premium: "Premium",
    },
    methods: {
        efectivo: "Efectivo",
        transferencia: "Transferencia",
        vale: "Vale",
        tarjeta_combustible: "Tarjeta",
    },
    table: {
        date: "Fecha",
        asset: "Activo",
        operator: "Operador",
        job: "Trabajo",
        noJob: "Sin trabajo",
        fuelType: "Tipo",
        liters: "Litros",
        cost: "Costo",
        pricePerLiter: "$/L",
        kmPerLiter: "km/L",
        method: "Pago",
        voucher: "Vale",
        receipt: "Ticket",
        actions: "",
    },
    form: {
        title: "Nueva carga de combustible",
        editTitle: "Editar carga",
        asset: "Activo",
        pickAsset: "Selecciona un activo",
        date: "Fecha",
        fuelType: "Tipo de combustible",
        liters: "Litros",
        totalCost: "Costo total (MXN)",
        paymentMethod: "Método de pago",
        voucher: "Número de vale / folio",
        operator: "Operador",
        pickOperator: "Selecciona un operador (opcional)",
        job: "Vincular a trabajo (opcional)",
        noJob: "Sin trabajo (carga general)",
        odomIn: "Odómetro entrada (km)",
        odomOut: "Odómetro salida (km)",
        hourIn: "Horómetro entrada",
        hourOut: "Horómetro salida",
        receipt: "Foto del ticket (opcional)",
        notes: "Notas (opcional)",
        save: "Guardar",
        cancel: "Cancelar",
        livePriceHint: "$ / L: {price}",
    },
    operatorHome: {
        chargeBtn: "Cargar combustible",
        modalTitle: "Registrar carga de combustible",
    },
    anomalyTooltip: "Anomalía detectada",
};


// ============================================================
// Phase 9 — Attendance con job_id + Mis Trabajos tabs + Horas tab
// ============================================================
dict.nav.hours = "Horas";

dict.myJobsTabs = {
    active: "Activos",
    upcoming: "Futuros",
    past: "Pasados",
    empty: {
        active: "Sin trabajos activos en este momento.",
        upcoming: "No tienes trabajos programados próximos.",
        past: "Sin trabajos pasados registrados.",
    },
    loadMore: "Cargar más",
};

dict.hours = {
    title: "Mis horas",
    subtitle: "Registro de tus jornadas y horas por trabajo.",
    thisWeek: "Esta semana",
    totalWorked: "Total trabajado",
    byJob: "Por trabajo",
    general: "General (sin trabajo)",
    ranges: {
        today: "Hoy",
        thisWeek: "Esta semana",
        thisMonth: "Este mes",
        lastMonth: "Mes pasado",
        custom: "Rango personalizado",
    },
    sessions: "Sesiones",
    empty: "Sin sesiones registradas en este rango.",
    ongoing: "En curso",
    duration: "Duración",
    checkInNote: "Nota de inicio",
    checkOutNote: "Nota de cierre",
    viewNotes: "Ver notas",
    hideNotes: "Ocultar notas",
    startShiftBtn: "Iniciar jornada",
    endShiftBtn: "Terminar jornada",
    changeJobBtn: "Cambiar trabajo",
    loadError: "Error al cargar tus horas",
    hourShort: "h",
    minuteShort: "min",
};

dict.attendance = dict.attendance || {};
dict.attendance.pickJob = "Trabajo (opcional)";
dict.attendance.pickJobGeneral = "General (sin trabajo específico)";
dict.attendance.pickJobPlaceholder = "Selecciona un trabajo o deja General";
dict.attendance.noteLabel = "Nota (opcional)";
dict.attendance.notePlaceholder = "Ej. entré tarde, cliente pidió pausa…";
dict.attendance.startModalTitle = "Iniciar jornada";
dict.attendance.endModalTitle = "Terminar jornada";
dict.attendance.startBtn = "Iniciar";
dict.attendance.endBtn = "Terminar";
dict.attendance.cancel = "Cancelar";
dict.attendance.ongoingBanner = "En jornada desde {time}";
dict.attendance.jobInProgress = "Trabajo: {job} ({client})";
dict.attendance.workingGeneral = "Trabajo: General (sin trabajo específico)";
dict.attendance.changeJobConfirm = "¿Cambiar de trabajo? Se cerrará la jornada actual e inmediatamente iniciarás una nueva.";


// ============================================================
// Phase 8F — Calendario de flota
// ============================================================
dict.nav.calendar = "Calendario";
dict.nav.audit = "Auditoría";
dict.nav.resetRequests = "Solicitudes de recuperación";
dict.nav.wipeDb = "Borrar datos";
dict.nav.manuals = "Manuales";

dict.manuals = {
    title: "Manuales",
    subtitle: "Guías de referencia para administradores y operadores.",
    empty: "No hay manuales disponibles.",
    loadError: "No se pudo cargar el manual.",
    view: "Ver en línea",
    download: "Descargar",
    close: "Cerrar",
    backToList: "Volver a la lista",
    items: {
        "manual-superadmin.md": {
            title: "Manual del Administrador",
            description: "Guía completa para superadmins y admins: configuración inicial, trabajos, finanzas, mantenimiento, auditoría.",
        },
        "manual-operador.md": {
            title: "Manual del Operador",
            description: "Cómo instalar la PWA, iniciar jornada, registrar campo, subir fotos, trabajar sin conexión.",
        },
    },
};

dict.calendar = {
    title: "Calendario de flota",
    subtitle: "Qué está haciendo cada activo, día por día.",
    views: {
        month: "Mes",
        week: "Semana",
        day: "Día",
    },
    today: "Hoy",
    prev: "Anterior",
    next: "Siguiente",
    loading: "Cargando calendario…",
    loadError: "Error al cargar el calendario",
    rangeTooBig: "El rango no puede exceder 92 días (≈ 3 meses).",
    filters: {
        title: "Filtros",
        assets: "Activos",
        types: "Tipo",
        kindCamion: "Camión",
        kindMaquinaria: "Maquinaria",
        clear: "Limpiar filtros",
        showFilters: "Mostrar filtros",
        hideFilters: "Ocultar filtros",
    },
    legend: {
        inUse: "En trabajo",
        rental: "En renta",
        maintenance: "Mantenimiento",
        outOfService: "Fuera de servicio",
        available: "Disponible",
    },
    empty: {
        noFilterMatch: "No hay activos que cumplan los filtros seleccionados.",
        noActivity: "Sin actividad en este periodo.",
    },
    headers: {
        asset: "Activo",
    },
    weekdaysShort: ["D", "L", "M", "M", "J", "V", "S"],
    weekdaysLong: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
    months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
             "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
    periodLabels: {
        weekOf: "Semana del {from} al {to}",
        weekOfSameMonth: "Semana del {from_d} al {to_d} de {month_year}",
        dayFull: "{weekday} {d} de {month} {y}",
    },
    cellLabels: {
        available: "Disponible",
        outOfService: "Fuera de servicio",
        maintenance: "Mantenimiento",
    },
    tooltip: {
        client: "Cliente",
        job: "Trabajo",
        rental: "Renta",
        maintenance: "Mantenimiento",
    },
};


// ============================================================
// Phase 8D — Renta (clasificación de trabajos como renta de activos)
// ============================================================
dict.jobs.classLabel.renta = "Renta";
dict.jobs.fields.renta = "Renta (sin operador propio)";
dict.jobs.fields.rentalMode = "Periodicidad";
dict.jobs.fields.rentalModeMensual = "Mensual";
dict.jobs.fields.rentalModeSemanal = "Semanal";
dict.jobs.fields.rentalPeriodCount = "Periodos contratados";
dict.jobs.fields.rentalAmountPerPeriod = "Monto por periodo (MXN)";
dict.jobs.fields.rentalStartDate = "Inicio de renta";
dict.jobs.fields.rentalAutoRenew = "Renovación automática";
dict.jobs.fields.rentalGraceDays = "Días de gracia";
dict.jobs.fields.rentalPeriodsCompleted = "Periodos cobrados";
dict.jobs.fields.rentalCurrentPeriodEnd = "Fin del periodo actual";
dict.jobs.fields.rentalTotalContract = "Total del contrato";
dict.jobs.fields.rentalAccruedRevenue = "Ingreso devengado";

dict.jobs.sections.rental = "Términos de renta";

dict.jobs.info.rentaDescription = "El cliente opera el activo. Se cobra por periodo (mensual o semanal). No se asignan operadores propios.";
dict.jobs.info.rentaNoOperators = "Renta: el cliente provee al operador. No se asignan operadores propios.";
dict.jobs.info.rentalAutoRenewHint = "Si está activa, la app suma automáticamente un periodo al vencer (más los días de gracia) y registra el ingreso.";
dict.jobs.info.rentalManualHint = "Sin renovación automática: deberás avanzar el periodo manualmente al cobrar.";
dict.jobs.info.rentalAdvancePeriod = "Avanzar un periodo";
dict.jobs.info.rentalAdvanceConfirm = "¿Avanzar un periodo? Se sumará el monto al ingreso devengado del trabajo.";
dict.jobs.info.rentalAdvanceSuccess = "Periodo avanzado correctamente";
dict.jobs.info.rentalAllPeriodsDone = "Renta completada: todos los periodos cobrados";
dict.jobs.info.rentalNoMoreAdvance = "No se puede avanzar: la renta ya cubrió todos los periodos contratados";

dict.jobs.fields.rentalAdvanceHistory = "Historial de cobros";
dict.jobs.fields.rentalAdvanceSourceManual = "Manual";
dict.jobs.fields.rentalAdvanceSourceAuto = "Auto";

dict.rentalsExpiring = {
    title: "Rentas próximas a vencer",
    subtitle: "Periodos que terminan en los próximos 7 días",
    empty: "Sin rentas por vencer en los próximos 7 días",
    loadError: "Error al cargar rentas por vencer",
    daysLabel: "días",
    today: "Hoy",
    overdue: "Vencido",
    autoRenewOn: "Auto",
    autoRenewOff: "Manual",
    period: "Periodo",
};

export function t(path) {
    return path.split(".").reduce((acc, k) => (acc && acc[k] != null ? acc[k] : path), dict);
}
export default dict;
